<template>
<el-form ref="form" :model="form">
  <el-form-item label="请输入获奖名称">
    <el-input v-model="form.name"></el-input>
  </el-form-item>
  <el-form-item >
    <el-checkbox v-model="form.issub">是否有分类</el-checkbox>
  </el-form-item>

  <el-form-item>
    <el-button type="primary" @click="onSubmit">立即创建</el-button>
    <el-button>取消</el-button>
  </el-form-item>
  {{form.issub}}
  <div v-if="form.issub">
    <el-row :gutter="20">
      <el-col :span="4"><div class="grid-content bg-purple"></div></el-col>
      <el-col :span="16">
        <div class="grid-content bg-purple">
          <el-input v-model="awardsSub.sname" placeholder="请输入分类名称"></el-input>
          <el-button type="primary" @click="saveSub()">保存分类</el-button>
        </div>
      </el-col>
      <el-col :span="4"><div class="grid-content bg-purple"></div></el-col>
    </el-row>
  </div>
</el-form>
</template>
<script>
  export default {
  name: 'Addawards',
    data() {
      return {
        form: {
          name: '',
          issub: 0
        },
        awardsSub: {
          sname: '',
          awardId:''
        }
      }
    },
    watch:{
      form:{
            handler:function(val,oldval){
                console.log(val.issub)
            },
            deep:true//对象内部的属性监听，也叫深度监听
        }
    },
    methods: {
      onSubmit() {
        this.$http.post('/api/awards/addawards', this.form).then(  //添加奖项
          (response) => {
             console.log(response);
               this.awardsSub.awardId = response.body.awardId;
             //console.log(this.awardsSub.aid)
          },
          (response) => {
             console.log(response);
          }
        )
      },
      saveSub() {
      console.log(this.awardsSub);
        this.$http.post('/api/awards/addawardssub', this.awardsSub).then(   //添加奖项分类
            (response) => {
               console.log(response);
            },
            (response) => {
               console.log(response);
            }
          )
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Addawards.vue